module.exports = __webpack_public_path__ + "static/media/engagePeoLogo1.f73ef682.jpg";